'use client'
import {
  EVENT_LIST_QUERY
} from "./chunk-E577PGQH.mjs";

// src/api/queries/auctionList.ts
var AUCTION_LIST_QUERY = `
${EVENT_LIST_QUERY}
startAt
endAt
upfrontPayment
`;

export {
  AUCTION_LIST_QUERY
};
//# sourceMappingURL=chunk-NPNDRLDV.mjs.map